/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{height:100%;display:flex;flex-direction:column}[_nghost-%COMP%]     .panel-container{height:100%}app-details-tab[_ngcontent-%COMP%]{height:100%}dx-data-grid[_ngcontent-%COMP%]{height:calc(100% - 53px)}"];
export { styles as styles };
